<template>
   <span>

       <a href="#"  @click.prevent="isOpen = !isOpen" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-pink-500 group-hover:text-pink-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
          </a>

    <transition v-if="isOpen"
                name="update-campaign-card-transition"
                enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-in duration-200 transform"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >
<!--      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto">-->
      <div   class="fixed z-10 inset-0 overflow-y-auto px-5 py-5">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all lg:my-8 lg:align-middle lg:max-w-4xl lg:w-full lg:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                   {{updateTextCurrent}}
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>
                <div class="space-y-5">


                <div>
                  <label for="title" class="block text-sm font-medium text-gray-700">
                    Title <sup class="text-red required">*</sup>
                  </label>
                  <div class="mt-1">
                    <input placeholder="Title" type="text" v-model="editForm.title" id="title" autocomplete="" class="w-full block sm:text-sm">
                  </div>
                </div>

                <div>
                  <label for="link" class="block text-sm font-medium text-gray-700">
                    Link <sup class="text-red required">*</sup>
                  </label>
                  <div class="mt-1">
                    <input placeholder="Link" type="text" v-model="editForm.link" id="link" autocomplete="" class="w-full block sm:text-sm">
                  </div>
                </div>

                  <div v-if="campaignCardType == `ad`">
                  <label for="button_name" class="block text-sm font-medium text-gray-700">
                    Button Name <sup class="text-red required">*</sup>
                  </label>
                  <div class="mt-1">
                    <input placeholder="Link" type="text" v-model="editForm.button_name" id="button_name" autocomplete="off" class="w-full block sm:text-sm">
                  </div>
                </div>


                   <div>
                    <label for="link" class="block text-sm font-medium text-gray-700">
                      Image <sup class="text-red required">*</sup>
                                <span>{{this.editForm.image}}</span>

                    </label>
                    <div class="border-2 border-gray-300 border-dashed">
<!--                      <vue-dropzone ref="myVueDropzone2" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent"></vue-dropzone>-->
                      <DropZone
                          ref="dropzone2"
                          url="https://giving.side-out.org/add-campaign-card-image"
                          :maxFiles="1"
                          :uploadOnDrop="false"
                          :multipleUpload="false"
                          :headers="{'x-csrf-token': this.token}"
                          @sending="sendingEvent"
                      >
                      <template v-slot:message><p>To upload your logo/icon, drop a JPG, GIF or PNG file you would like to use here.</p></template>
                    </DropZone>
                    </div>
                  </div>


                  <div>
                  <label for="description" class="block text-sm font-medium text-gray-700">
                    Description <sup class="text-red required">*</sup>
                  </label>
                  <div class="mt-1">
                    <textarea id="description" v-model="editForm.description" rows="3" class="w-full block sm:text-sm" placeholder="Description"></textarea>
                  </div>
                </div>

                </div>

            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="updateCard" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
               {{updateTextCurrent}}
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>


        </div>
      </div>
      </div>

    </transition>
   </span>
</template>

<script>

import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';


export default {
  name: 'UpdateCampaignCardModal',
  components: {
    DropZone
  },
  props: {
    campaignCard: {
      type: Object,
      required: true,
    },
    campaignCardType: {
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      editForm: {
        link: null,
        image: null,
        title: null,
        description: null,
        button_name: null,
      },
      updateText : 'Update Card',
    }
  },
  created() {

    this.updateText = 'Update Card: '+this.campaignCard.title

    this.editForm.link = this.campaignCard.link;
    this.editForm.image = this.campaignCard.image;
    this.editForm.title = this.campaignCard.title;
    this.editForm.description = this.campaignCard.description;
    this.editForm.id = this.campaignCard.id;
  },
  methods: {
    sendingEvent (file, xhr, formData) {
      formData.append('_token', this.token);
      formData.append('campaign_card_id', this.campaignCard.id);
    },
    updateCard() {

      if (!this.editForm.title) {
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      if (!this.editForm.link) {
        this.$notify({
          text: 'Link is required',
          type: 'error',
        })
        return
      }
      if (!this.editForm.description) {
        this.$notify({
          text: 'Description is required',
          type: 'error',
        })
        return
      }

      this.updateText = 'Updating Card: '+this.editForm.title+'...'

      axios.post('/edit-campaign-card', this.editForm)
          .then(response => {
            this.$notify({text: 'Card: '+this.editForm.title+' updated',type: 'success', })

            this.$refs.dropzone2.processQueue()

            setTimeout(() => {
              this.isOpen = false;
              this.emitter.emit('campaign-card-updated');
            }, 1000)
          })
    }
  },
  computed: {
    token() {
      return $('meta[name="csrf-token"]').attr('content')
    },
    updateTextCurrent() {
      return this.updateText
    },
  },

}
</script>
